module.exports = __webpack_public_path__ + "img/crocodile.bf8b8db.png";